export default "__VITE_ASSET__DHfKScpC__"